import { AUTH_0_API, CHECK_AUTHORIZATION_API, FORGOT_PASSWORD, LOGIN, REFRESH_TOKENS_API, REGENERATE_2FA, REGISTER, RESET_PASSWORD, VERIFY_2FA, VERIFY_ACCOUNT_API, VERIFY_TOTP_OTP, TOTP_SETUP, LOST_DEVICE, VERIFY_TO_RESET_TOTP } from '../constants/api-path';
import httpClient from './http.interceptor';

/**
 * @param {email: string, password:string} formData
 * @returns Promise<any>
 */
export const loginEmailPasswordAPI = (formData: any): Promise<any> => {
    return httpClient.post(LOGIN, formData);
};

/**
 * @param {fullName: string, email: string, password:string} formData
 * @returns Promise<any>
 */
export const registerUserAPI = (formData: any): Promise<any> => {
    return httpClient.post(REGISTER, formData);
};

/**
 * @param {email: string} formData
 * @returns Promise<any>
 */
export const forgotPasswordAPI = (formData: any): Promise<any> => {
    return httpClient.post(FORGOT_PASSWORD, formData);
};

/**
 * @param {token: string, password: string } formData
 * @returns Promise<any>
 */
export const resetPasswordAPI = (formData: any): Promise<any> => {
    return httpClient.post(RESET_PASSWORD, formData);
};

/**
 * @param {code: string, email: string } formData
 * @returns Promise<any>
 */
export const verify2faAPI = (formData: any): Promise<any> => {
    return httpClient.post(VERIFY_2FA, formData);
};

/**
 * @param {email: string } formData
 * @returns Promise<any>
 */
export const regenerate2faAPI = (formData: any): Promise<any> => {
    return httpClient.post(REGENERATE_2FA, formData);
};

/**
 * @param {token: string} formData
 * @returns Promise<any>
 */
export const accountEmailVerificationAPI = (formData: any): Promise<any> => {
    return httpClient.post(VERIFY_ACCOUNT_API, formData);
};

/**
 * @param { fullName: string, email: string, auth0: object } formData
 * @returns Promise<any>
 */
export const auth0LoginSignUpAPI = (formData: any): Promise<any> => {
    return httpClient.post(AUTH_0_API, formData);
};

/**
 * @param {refreshToken: string} formData
 * @returns Promise<any>
 */
export const refreshTokenAPI = (formData: any): Promise<any> => {
    return httpClient.post(REFRESH_TOKENS_API, formData);
};

/**
 * @param {token: string} formData
 * @returns Promise<any>
 */
export const loginAsVerificationAPI = (formData: any): Promise<any> => {
    return httpClient.post(CHECK_AUTHORIZATION_API, formData);
};

export const veryTOTPOTPApi = (formData: any): Promise<any> => {
    return httpClient.post(VERIFY_TOTP_OTP, formData);
};

export const totpSetupAndLogin = (formData: any): Promise<any> => {
    return httpClient.post(TOTP_SETUP, formData);
};

export const lostDeviceApi = (formData: any): Promise<any> => {
    return httpClient.post(LOST_DEVICE, formData);
};

export const verifyToResetTOTPAPI = (formData: any): Promise<any> => {
    return httpClient.post(VERIFY_TO_RESET_TOTP, formData);
};